.InboxPage {
  display: flex;
  flex-flow: row nowrap;
}

.LeftPane {
  display: flex;
  flex-flow: column nowrap;
  @media (min-width: 992px) {
    width: 20rem;
  }
}

.LeftPaneActions {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}

.NewConvo {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  width: 100%;
}

.ConvoList {
  margin-bottom: 1rem;
}

.ConvoTile {
  padding: 0.5rem;
  cursor: pointer;
  border-color: var(--bs-gray-500);
  border-style: solid;
  border-width: 1px 0 0 0;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  width: 100%;

  @media (min-width: 992px) {
    border-width: 0 1px 1px 0;
  }

  &:hover {
    background-color: var(--bs-gray-300);
  }

  &.Current {
    font-weight: 600;
    @media (min-width: 992px) {
      border-width: 0 0 1px 1px;
    }
  }

  & > .ConvoTileMain {
    flex-grow: 1;
    display: flex;
    flex-flow: column nowrap;
    width: calc(100% - 80px);

    & > .ConvoSubject {
      overflow-x: hidden;
      white-space: nowrap;
      font-size: 0.85rem;

      & img {
        width: 22px;
        padding-right: 5px;
        padding-bottom: 2px;
      }
    }

    & > .ConvoSubHeading {
      overflow-x: hidden;
      white-space: nowrap;
      font-size: 0.75rem;
    }
  }

  & > .ConvoTileDateTime {
    width: 60px;
    text-align: right;
    padding-left: 5px;
  }

  & > .ConvoTileUnread {
    width: 20px;
    color: var(--bs-pink);
    font-size: 2rem;
    line-height: 2rem;
  }
}

.VeryMuted {
  font-size: 0.75rem;
  color: var(--bs-gray-600);
}

.RightPane {
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  @media (min-width: 576px) {
    padding-left: 1rem;
  }
}

.OffcanvasButton {
  @media (min-width: 576px) {
    display: none;
  }
}

.ConvoHeader {
  & img {
    width: 20px;
    padding-right: 5px;
  }
}

.DayBreak {
  margin: 0.5rem auto;
  padding: 0.25rem 2rem;
  text-align: center;
  font-size: 0.75rem;
  color: var(--bs-gray-600);
  border-radius: 0.25rem;
  background-color: var(--bs-gray-100);
}

.MessageList {
  display: flex;
  flex-flow: column nowrap;
  gap: 0.25rem;
  justify-content: flex-end;
  margin-bottom: 1rem;
}

.MessageTile {
  border: 1px solid var(--bs-gray-500);
  border-radius: 1rem;
  border-bottom-left-radius: 0;
  padding: 0.5rem 0.75rem;
  width: fit-content;
  background-color: var(--bs-gray-100);
  display: flex;
  flex-flow: row nowrap;

  &.FromCurrentUser {
    align-self: flex-end;
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 0;
    background-color: rgba(42, 143, 230, 0.1);
  }

  &.Unread::after {
    content: '•';
    padding-left: 0.5rem;
    color: var(--bs-pink);
    font-size: 2rem;
    line-height: 1.2rem;
  }
}

.NewMessage {
  position: relative;
  /* margin-top: 1rem; */

  & > input {
    border: 1px solid var(--bs-gray-500);
    border-radius: 1rem;
    padding: 0.5rem 3rem 0.5rem 1rem;
    width: 100%;
  }

  & > span {
    position: absolute;
    top: -4px;
    right: 10px;
    font-size: 2rem;
    cursor: pointer;
  }
}
